import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip, { ALIGN, POSITION } from 'gnos-tooltip'
import moment from 'moment'
import cx from 'classnames'
import _ from 'lodash'

import TooltipContent from '../TooltipContent'

export default class ActiveDate extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object.isRequired,
        handleOnHover: PropTypes.func.isRequired,
        index: PropTypes.string.isRequired,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        pinnedIndex: PropTypes.string,
        pinParticipationElement: PropTypes.func.isRequired,
        startDate: PropTypes.string,
        timelineDurationInDays: PropTypes.number,
        timelineStartDate: PropTypes.object,
        translates: PropTypes.shape({
            from: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            to: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    handleOnMouse = (attributes) => () => {
        this.props.handleOnHover(attributes)
    }

    handleOnClick = (attributes) => () => {
        const { module, block, customData, index, pinParticipationElement, mainId } = this.props
        this.props.handleOnHover(attributes, true)

        const currentPinnedIndex = _.get(customData, 'pinnedIndex', null)

        const newCustomData = {
            pinnedIndex: currentPinnedIndex === index ? null : index,
        }

        pinParticipationElement(module, mainId, block, newCustomData)
    }

    render() {
        const { timelineDurationInDays, timelineStartDate, startDate, index, name, translates, pinnedIndex } =
            this.props

        // Get difference between the start of the timeline and the start of the element in days (based on startDates)
        const elementMargin = moment(startDate).diff(timelineStartDate, 'days')
        // Get position of element on timeline (percentage)
        const left = (elementMargin / timelineDurationInDays) * 100 + 1

        return (
            <div
                onMouseEnter={this.handleOnMouse({ width: 100, left })}
                onMouseLeave={this.handleOnMouse({})}
                onClick={this.handleOnClick({ width: 100, left })}
            >
                <Tooltip
                    id={`participation-tooltip-${index}`}
                    content={
                        <TooltipContent startDate={startDate} endDate={null} name={name} translates={translates} />
                    }
                    width={'125px'}
                    align={ALIGN.CENTER}
                    position={POSITION.TOP}
                    style={{ textAlign: 'center' }}
                >
                    <div
                        style={{
                            left: `${left}%`,
                            // Add a little bit of overflow (101%) so that the round corners are not visible
                            // Can't be just 100% because of tooltips
                            width: `${101 - left}%`,
                        }}
                        className={cx('participation-element', 'active', pinnedIndex === index ? 'pinned' : 'pin')}
                    >
                        <div className={cx('pin-icon')} />
                    </div>
                </Tooltip>
            </div>
        )
    }
}
